import { Alert, Platform } from 'react-native'
import * as util from '../util/util'


const alertPolyfill = (title, description, acao) => {
    const result = window.confirm([title, description].filter(Boolean).join('\n'))

    if (acao!=null) {
        if (result) {
          
            util.print("alerta confirmado!");
            acao();
        }
    }
}

const alert = Platform.OS === 'web' ? alertPolyfill : Alert.alert

export default alert